import React, { useMemo } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner } from '@elastic/eui';
import { WrapperLogin } from './wrapper';
import { useUserSettings } from '../../../context/CurrentUserContext';

export const InitialRouteByProfile = () =>{

    const  {currentUser} = useUserSettings();

    //const a = undefined;

    const Loading = () =>
        <EuiFlexGroup direction='column' alignItems='center'>
          <EuiFlexItem><EuiLoadingSpinner size='xl'/></EuiFlexItem>
          <EuiFlexItem>Redireccionando...</EuiFlexItem>
        </EuiFlexGroup>
    
    // const getInitialPage = useMemo(()=> currentUser!==undefined ? <WrapperLogin currentUser={currentUser}/> : Loading(),[currentUser])

    //const InitialProfile = useMemo(()=>(currentUser!==undefined && currentUser.perfil!==undefined) ? currentUser.perfil : undefined,[currentUser])
    
    const getInitialPage = useMemo(()=> currentUser!==undefined ? <WrapperLogin currentUser={currentUser}/> : Loading(),[currentUser,Loading])

    return getInitialPage;
   
}